<template>
  <div class="jsc-bg">
    <div class="top">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">{{ discrib.name }}</div>
      <div class="sys-temp"><div id="he-plugin-simple"></div></div>
    </div>
    <div>
      <my-scale @changeSize="changeSize">
        <div
          :style="{
            'margin-top': 'calc(' + mySize + 'vw' + ' + 16px',
          }"
          class="d-column d-center d-allcenter"
          style="width: 1920px"
        >
          <div class="order-top d-aligncnter" style="height: 880px; position: relative">
            <div style="position: absolute; bottom: -60px; width: 100%; left: 0">
              <img src="@/assets/img/venuesorder/groupline2.svg" style="width: 100%" />
            </div>
            <div class="order-left d-column">
              <div class="left-top" style="height: 207px">
                <div class="d-aligncnter" style="font-size: 20px">
                  <img src="@/assets/img/venuesorder/dashboard-one.svg" style="margin-right: 8px" /><span
                    >场馆累计预约人次</span
                  >
                </div>
                <div class="nums-box d-allcenter">
                  <div
                    class="allNum d-allcenter"
                    v-for="(item, index) in String(totalData.total).length"
                    :key="'num_' + index"
                  >
                    {{ String(totalData.total)[index] }}
                  </div>
                  <div class="d-allcenter" style="color: #007a4d; font-size: 14px; height: 48px">人</div>
                </div>
                <div class="d-allcenter line-div" style="margin-top: 8px">
                  <img src="@/assets/img/venuesorder/line.svg" />
                </div>
                <div class="d-aligncnter d-center d-around" style="font-size: 18px; margin-top: 8px">
                  <div class="d-column d-aligncnter" style="width: 33%">
                    <div>预约名额</div>
                    <div class="box-one-font" style="color: #00ffa1; margin-top: 8px">{{ totalData.count }}</div>
                  </div>
                  <div class="d-column d-aligncnter" style="width: 33%">
                    <div>今日预约</div>
                    <div class="box-one-font" style="color: #ffb612; margin-top: 8px">{{ totalData.jryy }}</div>
                  </div>
                  <div class="d-column d-aligncnter" style="width: 33%">
                    <div>今日进场</div>
                    <div class="box-one-font" style="color: #009afe; margin-top: 8px">{{ totalData.jrrc }}</div>
                  </div>
                </div>
                <div class="d-allcenter line-div">
                  <img src="@/assets/img/venuesorder/line.svg" />
                </div>
              </div>
              <div class="left-bottom" style="height: 212px">
                <div class="d-aligncnter" style="font-size: 20px; margin-bottom: 8px">
                  <img src="@/assets/img/venuesorder/sun.svg" style="margin-right: 8px" /><span>天气信息</span>
                </div>
                <div>
                  <div class="d-aligncnter">
                    <div class="d-allcenter weather-img">
                      <!-- <img src="@/assets/img/venuesorder/sun.svg" /> -->
                      <i :class="getCurrIcon()"></i>
                    </div>
                    <div style="font-size: 14px; margin-left: 8px; width: calc(100% - 52px)">
                      <div style="color: #00ffa1; width: 100%" class="overflow">
                        {{ weatherData.weatherText }} {{ weatherData.temp }}°C，风力{{ weatherData.windScale }}级
                      </div>
                      <div class="overflow2" style="width: 100%" :title="weatherData.sportsText">
                        {{ weatherData.sportsText }}
                      </div>
                    </div>
                  </div>
                  <div class="d-around" style="margin-top: 8px">
                    <div class="weather-each">
                      <div class="each-title d-allcenter">湿度</div>
                      <div class="d-column d-aligncnter" style="padding: 8px 0">
                        <img src="@/assets/img/venuesorder/wet.svg" />
                        <div style="color: #00ffa1">{{ weatherData.humidity }}%</div>
                      </div>
                    </div>
                    <div class="weather-each">
                      <div class="each-title d-allcenter">紫外线</div>
                      <div class="d-column d-aligncnter" style="padding: 8px 0">
                        <img src="@/assets/img/venuesorder/uv.svg" />
                        <div style="color: #00ffa1">{{ weatherData.uvIndex }}</div>
                      </div>
                    </div>
                    <div class="weather-each">
                      <div class="each-title d-allcenter">运动指数</div>
                      <div class="d-column d-aligncnter" style="padding: 8px 0">
                        <img src="@/assets/img/venuesorder/sport.svg" />
                        <div style="color: #00ffa1">{{ weatherData.sportsCategory }}</div>
                      </div>
                    </div>
                    <div class="weather-each">
                      <div class="each-title d-allcenter">AQI</div>
                      <div class="d-column d-aligncnter" style="padding: 8px 0">
                        <img src="@/assets/img/venuesorder/air.svg" />
                        <div style="color: #00ffa1">
                          {{ weatherData.aqi
                          }}<span
                            style="
                              background: #007a4d;
                              color: #fff;
                              padding: 1px 2px;
                              border-radius: 4px;
                              margin-left: 4px;
                            "
                            >{{ weatherData.airCategory }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="left-bottom" style="height: 212px">
                <div class="d-aligncnter" style="font-size: 20px; margin-bottom: 8px">
                  <img src="@/assets/img/venuesorder/chart-line.svg" style="margin-right: 8px" /><span
                    >场馆实时人流量</span
                  >
                </div>
                <div class="echarts">
                  <div
                    id="chart-one"
                    :style="{
                      width: '250px',
                      height: '120px',
                      margin: '8px auto',
                    }"
                  ></div>
                </div>
              </div>
              <div class="left-bottom" style="height: 212px">
                <div class="d-aligncnter" style="font-size: 20px; margin-bottom: 8px">
                  <img src="@/assets/img/venuesorder/chart-line2.svg" style="margin-right: 8px" /><span
                    >场馆项目流量统计</span
                  >
                </div>
                <div class="echarts">
                  <div
                    id="chart-two"
                    :style="{
                      width: '250px',
                      height: '120px',
                      margin: '8px auto',
                    }"
                  ></div>
                </div>
              </div>
            </div>
            <div class="order-center d-column" style="height: calc(100% - 64px); margin-top: 24px">
              <div style="position: absolute; top: -38px; width: 100%; left: 0">
                <img src="@/assets/img/venuesorder/groupline.svg" style="width: 100%" />
              </div>

              <div class="d-aligncnter select-option" style="margin-top: 0px">
                <!-- <div style="width: 36px; height: 36px; cursor: pointer" class="d-allcenter" @click="leftDayClick">
                  <img src="@/assets/img/venuesorder/btn-left.svg" style="width: 100%" />
                </div> -->

                <div
                  class="items-tab d-allcenter"
                  v-for="(item, index) in tabsList"
                  :key="'cd_' + index"
                  :class="tabsIndex == index ? 'tab-curr' : ''"
                  @click="tabsIndex = index"
                >
                  {{ item.areaName }}
                </div>
                <!-- <div
                  style="width: 36px; height: 36px; cursor: pointer; margin-right: 8px"
                  class="d-allcenter"
                  @click="rightDayClick"
                >
                  <img src="@/assets/img/venuesorder/btn-right.svg" style="width: 100%" />
                </div> -->
              </div>
              <div
                v-if="areaList.length == 0 || tiemList.length == 0"
                class="d-allcenter d-column"
                style="
                  width: 1216px;
                  height: 810px;
                  border-radius: 4px;
                  border: 1px solid #007a4d;
                  background: #003622;
                  margin-top: 8px;
                "
              >
                <img src="@/assets/img/venuesorder/empty.png" style="width: 344px" />
                <div style="font-size: 18px">暂未开放预约</div>
              </div>
              <div style="margin-top: 8px" class="order-table" v-else>
                <el-table
                  :data="tableData"
                  border
                  style="width: 100%"
                  max-height="770"
                  :cell-style="cellStyle"
                  :header-cell-style="headerCellStyle"
                >
                  <el-table-column fixed label="片场/时间" width="110" align="center">
                    <template slot-scope="scope">
                      <div class="d-allcenter" style="color: #fff">{{ areaList[scope.$index].name }}</div></template
                    >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="date"
                    :label="item"
                    :width="flexWidth"
                    v-for="(item, index) in tiemList"
                    :key="'time_' + index"
                  >
                    <template slot-scope="scope">
                      <div style="min-height: 42px" :style="{ height: 'calc(710px / ' + areaList.length + ' - 10px)' }">
                        <div
                          class="d-allcenter"
                          style="color: #fff; font-size: 14px; height: 100%"
                          v-if="!!tableData[scope.$index][index].teacherName"
                        >
                          上课
                        </div>
                        <div
                          class="d-allcenter"
                          style="color: #fff; font-size: 14px; height: 100%"
                          v-else-if="!!tableData[scope.$index][index].eventName"
                        >
                          训练
                        </div>
                        <div
                          class="d-allcenter"
                          style="color: #fff; font-size: 14px; height: 100%"
                          v-else-if="!!tableData[scope.$index][index].state"
                        >
                          {{ tableData[scope.$index][index].state }}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="order-right">
              <div class="right-top">
                <div class="d-aligncnter" style="font-size: 20px; margin-bottom: 8px">
                  <img src="@/assets/img/venuesorder/card.svg" style="margin-right: 8px" /><span>场馆预约类型</span>
                </div>
                <div class="d-around" style="font-size: 14px; padding-top: 8px">
                  <div class="d-column d-aligncnter">
                    <el-progress
                      type="circle"
                      :percentage="typeData.student"
                      :width="64"
                      color="#009AFE"
                      define-back-color="#007A4D4D"
                      text-color="#FFFFFF"
                    ></el-progress>
                    <div class="mt-8">学生</div>
                  </div>
                  <div class="d-column d-aligncnter">
                    <el-progress
                      type="circle"
                      :percentage="typeData.teacher"
                      :width="64"
                      color="#F97423"
                      define-back-color="#007A4D4D"
                      text-color="#FFFFFF"
                    ></el-progress>
                    <div class="mt-8">教职工</div>
                  </div>
                  <div class="d-column d-aligncnter">
                    <el-progress
                      type="circle"
                      :percentage="typeData.OffCampus"
                      :width="64"
                      color="#DE3831"
                      define-back-color="#007A4D4D"
                      text-color="#FFFFFF"
                    ></el-progress>
                    <div class="mt-8">校外人员</div>
                  </div>
                </div>
              </div>
              <div class="right-center">
                <div class="d-aligncnter" style="font-size: 20px; margin-bottom: 8px">
                  <img src="@/assets/img/venuesorder/fire.svg" style="margin-right: 8px" /><span>场馆预约热度</span>
                </div>

                <div style="font-size: 12px; height: 80px" class="d-aligncnter d-column">
                  <div class="d-aligncnter d-end" style="height: 60px">
                    <img
                      v-for="(item, index) in popularData"
                      :key="'pop_' + index"
                      src="@/assets/img/venuesorder/bar.png"
                      style="width: 36px; height: 50%"
                      :style="{ height: (Number(item.count) / popularCount) * 100 + '%' }"
                    />
                  </div>
                  <div class="d-aligncnter" style="height: 100%">
                    <div
                      style="width: 36px; text-align: center"
                      v-for="(item, index) in popularData"
                      :key="'pop2_' + index"
                    >
                      {{ item.week }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-bottom" style="height: 295px">
                <div class="d-aligncnter" style="font-size: 20px; margin-bottom: 8px">
                  <img src="@/assets/img/venuesorder/time.svg" style="margin-right: 8px" /><span>场馆实时入场名单</span>
                </div>

                <div style="border-radius: 4px; overflow: hidden">
                  <div style="overflow: hidden; height: 268px" @mouseenter="stopScrollTwo" @mouseleave="startScrollTwo">
                    <table
                      class="left-table"
                      cellspacing="0"
                      :class="{ 'animated-top': animatedTop2 && this.enterDataList.length > 8 }"
                    >
                      <tr
                        class="tr-data"
                        v-for="(item, index) in enterDataList"
                        :key="'enter_' + index"
                        :class="index % 2 == 1 ? 'color-tr' : ''"
                      >
                        <!-- <td class="college-name td-1 overflow">{{ item.cg }}</td> -->
                        <td class="td-2 overflow" style="width: calc(100% - 68px); text-align: left; padding-left: 8px">
                          {{ item.xm }}
                        </td>
                        <td class="td-3" style="width: 60px; white-space: nowrap">{{ item.sj.substr(-8) }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div
                class="back-all"
                style="width: 288px; height: 192px; position: relative; margin-top: 16px; cursor: pointer"
                @click="backLastPage"
              >
                <div
                  style="
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    border: 1px solid #000;
                    background: linear-gradient(0deg, #007a4d 0%, rgba(0, 122, 77, 0) 30.73%);
                  "
                ></div>
                <div
                  class="d-around d-aligncnter"
                  style="position: absolute; bottom: 4px; color: #00ffa1; font-size: 16px; margin-left: 6px"
                >
                  <img
                    src="@/assets/img/venuesorder/polygon.svg"
                    style="width: 16px; height: 17px; margin: 4px"
                    v-for="item in 8"
                    :key="'num_' + item"
                  />
                  返回总舱
                  <img src="@/assets/img/venuesorder/polygon2.svg" style="width: 16px; height: 17px; margin: 4px" />
                </div>

                <img :src="discrib.img" style="width: 100%; height: 100%" />
              </div>
            </div>
          </div>
        </div>
      </my-scale>
    </div>
  </div>
</template>
<script>
import {
  getAppointmentInfoByVenueId,
  getVenueAppointmentType,
  getAppointmentPopularityByVenueId,
  getEntranceByVenueId,
  getEachVenueCapacity,
  getAreas,
  getVenueOrderOpen,
  getVenueProfile,
  getTodayVenuePedestrianFlow,
  getVenueProjectTraffic,
  getWeather,
} from '@/api/api-venueCockpit'
import MyScale from '../components/MyScale.vue'
// import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: '',
  components: {
    MyScale,

    // vueSeamlessScroll,
  },
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      timerOne: null,
      timerTwo: null,
      optionBottom: {},
      optionHeart: {},
      stuList: [],
      currStuIndex: 0,
      classIndex: 0,
      searchKey: '',
      classList: [],

      allNumData: 146888,
      option: {},
      orderDate: '',
      inputData: '',
      tableData: [
        // [
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '《羽毛球2》', tea: '张三', status: 'class' },
        //   { name: '', tea: '', status: '' },
        //   { name: '《羽毛球1》', tea: '张三', status: 'class' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        // ],
        // [
        //   { name: '已预约', tea: '', status: 'order' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '《乒乓》', tea: '张三', status: 'class' },
        // ],
      ],
      tiemList: ['9:00', '10:00', '11:00', '9:00', '10:00', '11:00', '10:00', '11:00'],
      areaList: [{ name: '', id: '' }],
      todayPeople: {
        nums: [],
        times: [],
      },
      animatedTop: false,
      animatedTop2: false,
      enterDataList: [
        // { cg: '室内篮球场', xm: '张三', sj: '10:31:23' },
      ],
      currVenuesIndex: 0,
      allVenuesData: [
        // { name: '风雨操场', count_sy: '90', count: '100', status: true },
      ],
      totalData: {},
      typeData: {
        student: 0,
        teacher: 0,
        OffCampus: 0,
      },
      popularData: [],
      popularCount: 0,
      tabsIndex: 0,
      tabsList: [{ areaName: '场地1' }, { areaName: '场地2' }],
      discrib: {},
      currId: '',
      optionOne: {},
      optionTwo: {},
      itemData: { counts: [], items: [] },
      weatherData: {},
      weatherIcon: '',
    }
  },
  created() {
    let getMyDate = new Date()
    this.orderDate = getMyDate.getTime()
    window.addEventListener('load', this.placeholderPic)
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 9 ? date.month : '0' + date.month
    let newday = date.date > 9 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday

    // document.addEventListener('DOMContentLoaded', function () {
    //   const scrollDiv = document.getElementById('scroll-box')
    //   scrollDiv.addEventListener('wheel', function (e) {
    //     e.preventDefault()
    //     scrollDiv.scrollBy({ left: e.deltaY, behavior: 'smooth' })
    //   })
    // })
    this.currId = this.$route.query.venues
    console.log('this.currId:', this.currId)
  },
  computed: {
    getCurrIcon() {
      return function () {
        return 'qi-' + this.weatherData.weatherIcon + '-fill'
      }
    },
    // getCurrLeft() {
    //   return function (index) {
    //     if (index > this.stuList.length / 2) {
    //       return -500 + 'px'
    //     } else {
    //       return ''
    //     }
    //   }
    // },
    flexWidth() {
      if (this.tiemList.length > 9) {
        return 110
      } else {
        return 1106 / this.tiemList.length
      }
    },
    getCurrBox() {
      return function (item, index) {
        if (index == this.currVenuesIndex) {
          return 'box-curr'
        }
        if (item.status) {
          if (item.count == item.count_sy) {
            return 'box-full'
          } else {
            return 'box-normal'
          }
        } else {
          return 'box-null'
        }
      }
    },
  },
  mounted() {
    // this.startScrollOne()
    this.startScrollTwo()

    // 接口数据
    this.getAllAppointmentInfoData()
    this.getTodayVenuePedestrianFlowData()
    this.getVenueProjectTrafficData()
    this.getVenueAppointmentTypeData()
    this.getAppointmentPopularityByVenueIdData()
    this.getEntranceByVenueIdData()
    this.getEachVenueCapacityData()
    this.getWeatherData()
    setInterval(() => {
      this.getAllAppointmentInfoData()
      this.getTodayVenuePedestrianFlowData()
      this.getVenueProjectTrafficData()
      this.getVenueAppointmentTypeData()
      this.getAppointmentPopularityByVenueIdData()
      this.getEntranceByVenueIdData()
      this.getEachVenueCapacityData()
    }, 60000)
    // this.optionTwoInit()
    // this.drawMonthData()
    // window.onresize = () => {
    //   return (() => {})()
    // }
    window.WIDGET = {
      CONFIG: {
        modules: '02',
        background: '5',
        tmpColor: 'FFFFFF',
        tmpSize: '16',
        cityColor: 'FFFFFF',
        citySize: '16',
        aqiColor: 'FFFFFF',
        aqiSize: '16',
        weatherIconSize: '24',
        alertIconSize: '18',
        padding: '10px 10px 10px 10px',
        shadow: '0',
        language: 'auto',
        fixed: 'false',
        vertical: 'top',
        horizontal: 'left',
        key: '18dcc59e188b4b6684d470c4322bbefa',
      },
    }
    ;(function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
      var s = d.createElement('script')
      s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  methods: {
    // stopScrollOne() {
    //   clearInterval(this.timerOne)
    //   this.timerOne = null
    // },
    // startScrollOne() {
    //   this.timerOne = setInterval(() => {
    //     if (this.allAppointmentsList.length > 8) {
    //       this.animatedTop = true
    //       setTimeout(() => {
    //         this.allAppointmentsList.push(this.allAppointmentsList[0])
    //         this.allAppointmentsList.shift()
    //         this.animatedTop = false
    //       }, 500)
    //     } else {
    //       this.stopScrollOne()
    //     }
    //   }, 2000)
    // },
    stopScrollTwo() {
      clearInterval(this.timerTwo)
      this.timerTwo = null
    },
    startScrollTwo() {
      this.timerTwo = setInterval(() => {
        if (this.enterDataList.length > 8) {
          this.animatedTop2 = true
          setTimeout(() => {
            this.enterDataList.push(this.enterDataList[0])
            this.enterDataList.shift()
            this.animatedTop2 = false
          }, 500)
        } else {
          this.stopScrollTwo()
        }
      }, 2000)
    },
    leftDayClick() {
      console.log('orderDate:', this.orderDate)
      this.orderDate = this.orderDate - 3600 * 1000 * 24
      //   picker.$emit('pick', this.orderDate)
      console.log('orderDate:', this.orderDate)
    },
    rightDayClick() {
      console.log('orderDate:', this.orderDate)
      this.orderDate = this.orderDate + 3600 * 1000 * 24
      //   picker.$emit('pick', this.orderDate)
      console.log('orderDate:', this.orderDate)
    },
    cellStyle({ rowIndex, columnIndex }) {
      //   console.log('row:', row)
      //   console.log('column:', column)
      //   console.log('rowIndex:', rowIndex)
      //   console.log('columnIndex:', columnIndex)
      //   console.log('data:', this.tableData[rowIndex][columnIndex - 1])
      //   console.log('data:', this.tableData[rowIndex][columnIndex - 1].state)
      //   console.log('data:', this.tableData[rowIndex][columnIndex - 1].teacherName)
      //   console.log('data:', this.tableData[rowIndex][columnIndex - 1].eventName)
      if (columnIndex < 1) {
        return 'background: #003622'
      }

      if (this.tableData[rowIndex][columnIndex - 1].teacherName != '') {
        return 'background: #1AA4FE'
      } else if (this.tableData[rowIndex][columnIndex - 1].eventName != '') {
        return 'background: #9419F8'
      } else if (this.tableData[rowIndex][columnIndex - 1].state != '') {
        return 'background: #00A468'
      } else {
        return 'background: #003622'
      }
    },
    headerCellStyle() {
      return 'background: #003622;color:#fff'
    },
    changeCurrRace(item, index) {
      console.log('item:', item)
      this.currIndex = index
    },
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    changeSize(size) {
      console.log('size:', size)
      this.currScale = size
      this.mySize = 5.208 / size
    },
    //接口
    getAllAppointmentInfoData() {
      getAppointmentInfoByVenueId(this.currId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.totalData = res.data.obj
        }
      })
    },
    getTodayVenuePedestrianFlowData() {
      getTodayVenuePedestrianFlow().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.todayPeople = res.data.obj
          this.optionOneInit(this.todayPeople)
        }
      })
    },
    getVenueProjectTrafficData() {
      getVenueProjectTraffic(this.currId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.itemData = res.data.obj
          this.optionTwoInit(this.itemData)
        }
      })
    },
    getVenueAppointmentTypeData() {
      getVenueAppointmentType(this.currId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.typeData = res.data.obj
        }
      })
    },
    getAppointmentPopularityByVenueIdData() {
      getAppointmentPopularityByVenueId(this.currId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.popularData = res.data.obj
          let arr = []
          for (let i = 0; i < this.popularData.length; i++) {
            arr.push(Number(this.popularData[i].count))
            // this.popularCount += Number(this.popularData[i].count)
          }
          this.popularCount = Math.max(...arr)
        }
      })
    },
    getEntranceByVenueIdData() {
      getEntranceByVenueId(this.currId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.enterDataList = res.data.obj
        }
      })
    },
    getEachVenueCapacityData() {
      getEachVenueCapacity().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.allVenuesData = res.data.obj
          this.getAreasData()
          this.getVenueProfileData()
        }
      })
    },
    getAreasData() {
      getAreas(this.currId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getAreas:', res)
          this.tabsList = res.data.obj
          if (this.tabsList.length > 0) {
            this.getVenueOrderOpenData()
          } else {
            this.areaList = []
            this.tiemList = []
            this.tableData = []
          }
        }
      })
    },
    getVenueOrderOpenData() {
      let date = this.formatDate(this.orderDate)
      getVenueOrderOpen(this.tabsList[this.tabsIndex].areaId, date).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getVenueOrderOpenData:', res)
          this.areaList = res.data.obj.blocks
          this.tiemList = res.data.obj.times
          this.tableData = res.data.obj.list
        }
      })
    },
    getVenueProfileData() {
      getVenueProfile(this.currId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getVenueProfileData:', res)
          this.discrib = res.data.obj
        }
      })
    },
    getWeatherData() {
      getWeather().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getWeather:', res)
          this.weatherData = res.data.obj
        }
      })
    },
    formatDate(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}-${day}`
      return formattedDate
    },
    //操作
    venueClick(item, index) {
      this.currVenuesIndex = index
      console.log('venueClick item:', item)
      this.tabsIndex = 0
      this.getAreasData()
      this.getVenueProfileData()
    },
    changeDate() {
      this.tabsIndex = 0
      this.getAreasData()
    },
    backLastPage() {
      this.$router.go(-1)
    },
    optionOneInit(data) {
      var myChart = this.$echarts.init(document.getElementById('chart-one'))
      this.optionOne = {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: 16,
          right: 16,
          top: 20,
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data.times,
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
        },

        series: [
          {
            name: '人流量',
            type: 'line',
            symbol: 'none',
            smooth: true,
            sampling: 'lttb',
            itemStyle: {
              color: '#ffb61280 ',
            },
            areaStyle: {
              // linear-gradient(1deg, rgba(0, 122, 77, 0.07) 33.43%, rgba(255, 182, 18, 0.50) 115.65%);
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ffb61280' },
                { offset: 1, color: '#007a4d12' },
              ]),
            },
            data: data.nums,
          },
        ],
      }
      myChart.setOption(this.optionOne)
    },
    optionTwoInit(data) {
      console.log('data:', data)
      var myChart = this.$echarts.init(document.getElementById('chart-two'))
      this.optionTwo = {
        // legend: {
        //   data: ['项目流量'],
        //   right: '10%',
        //   top: '16',
        //   itemHeight: 8,
        //   itemWidth: 8,
        //   textStyle: {
        //     color: '#ffffff66',
        //   },
        // },
        tooltip: {},
        axisLabel: {
          color: '#ffffff66',
          fontSize: 12,
        },
        grid: {
          left: 16,
          right: 16,
          top: 20,
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            // rotate: 30,
            formatter: function (value) {
              if (value.length > 4) {
                return value.slice(0, 3) + '...'
              }
              return value
            },
          },
          data: data.items,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          minInterval: 1,
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)',
            },
          },
        },
        series: [
          {
            name: '项目流量',
            type: 'bar',
            stack: 'one',
            data: data.counts,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFB612' },
                { offset: 1, color: '#4DA282' },
              ]),
            },
          },
        ],
      }
      myChart.setOption(this.optionTwo)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/venues.scss';
.order-center::before {
  content: '';
  position: absolute;
  left: 608px;
  bottom: -19px;
}
.jsc-bg {
  width: 100vw;
  //   min-width: 1200px;
  height: 100vh;
  //   min-height: 800px;
  overflow: hidden;
  //   background: #09120f;
  //   background: #09120f url('../../../assets/img/cockpit/home-bg.svg') no-repeat
  //     center;
  background: #09120f no-repeat center;
  color: #fff;
  user-select: none;

  .top {
    width: 100%;
    height: 5.208vw;
    background: url('../../../assets/img/cockpit/top.svg') no-repeat;
    background-size: 100%;
    position: relative;

    .sys-title {
      width: 100%;
      height: 100%;
      line-height: 5.208vw;
      vertical-align: middle;
      text-align: center;
      font-size: 1rem;
    }

    .sys-date,
    .sys-temp {
      font-size: 0.5rem;
      position: absolute;
    }

    .sys-date {
      line-height: 44px;
      top: calc(2.604vw - 18px);
      left: 6vw;
    }

    .sys-temp {
      top: calc(2.604vw - 22px);
      right: 6vw;
      display: flex;
      flex-direction: row-reverse;
    }
  }
}

.sys-temp ::v-deep .s-sticker-tmp {
  font-size: 0.5rem !important;
}

.sys-temp ::v-deep img {
  height: 0.7rem !important;
  width: 0.7rem !important;
}

.sys-temp ::v-deep #weather-view-he {
  display: none !important;
}
::-webkit-scrollbar {
  display: none;
}

.ml-16 {
  margin-left: 16px;
}
.mt-8 {
  margin-top: 8px;
}
.select-option ::v-deep .el-input__inner,
.el-select-dropdown__item.is-disabled:hover {
  background-color: rgba(255, 255, 255, 0.01) !important;
}
.select-option ::v-deep .el-input__inner {
  border: 1px solid #007a4d !important;
  height: 36px;
  color: #fff;
}
.select-option ::v-deep .el-input__icon {
  line-height: 36px;
}

.el-table {
  border-bottom: 1px solid #007a4d;
  border-right: 1px solid #007a4d;
  margin: e auto;
}
::v-deep.el-table th {
  border: 1px solid #007a4d !important;
  border-right: none !important;
  border-bottom: none !important;
}
::v-deep.el-table td {
  border: 1px solid #007a4d;
  border-right: none !important;
  border-bottom: none !important;
}
.order-table ::v-deep .el-table .el-table__cell {
  padding: 5px 0;
}
// .order-table ::v-deep .cell {
//   min-height: 44px;
// }
.only {
  height: 44px;
  line-height: 44px;
}

.order-table ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  display: unset;
  width: 10px;
  height: 10px;
}

.order-table ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f5f7fa; // 设置背景颜色
  border-radius: 10px;
}

.order-table ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px; // 设置滑块边角半径
  background-color: #339571; // 设置滑块颜色及透明度
}
.order-table ::v-deep .el-table__fixed {
  bottom: 10px !important;
}
.animated-top {
  transition: all 0.5s;
  margin-top: -30px;
}
.weather-img {
  border-radius: 4px;
  border: 1px solid #007a4d;
  background: rgba(0, 255, 161, 0.1);
  padding: 12px;
  width: 34px;
}
.weather-each {
  border-radius: 4px;
  border: 1px solid #007a4d;
  font-size: 12px;
  width: 58px;
}
.each-title {
  border: 1px solid #007a4d;
  background: rgba(0, 255, 161, 0.1);
  color: #00ffa1;
  padding: 2px 0;
}
</style>
